export * from './gutachten-stati-sorter.component';
export * from './gutachten-stati-sorter.component.module';